import { isDeletedNoteEntry, isNoteEntry } from "@/features/notes/noteUtils";
import { type Opportunity, useHistory } from "@repo/api";
import { useSettings } from "@repo/ui";

import { groupHistoryEntries, maskHistoryEntries } from "../history/utils";

export const useNotes = (opportunity: Opportunity) => {
  const { data: historyEntries } = useHistory(opportunity.id);
  const { customerMode } = useSettings();

  const entries = customerMode
    ? maskHistoryEntries(historyEntries)
    : (historyEntries ?? []);

  const allEntries = entries;

  const groupedEntries = groupHistoryEntries(allEntries);

  const allNotes = groupedEntries.filter(
    (entry) => isNoteEntry(entry) && !isDeletedNoteEntry(entry)
  );

  const deletedByFlag = groupedEntries
    .filter((entry) => isDeletedNoteEntry(entry))
    .map((entry) => ({
      id: entry.id,
      note: entry.note ?? "",
      deletedBy: entry.updatedBy ?? entry.createdBy,
      deletedAt: entry.updatedAt ?? entry.createdAt,
    }));

  const deletedNotesById = deletedByFlag.reduce((acc, note) => {
    if (!acc.has(note.id)) {
      acc.set(note.id, note);
    }
    return acc;
  }, new Map<string, (typeof deletedByFlag)[number]>());

  const deletedNotes = [...deletedNotesById.values()].sort(
    (a, b) => new Date(b.deletedAt).getTime() - new Date(a.deletedAt).getTime()
  );

  const pinnedNotes = allNotes.filter((note) => note.isPinned);
  const unpinnedNotes = allNotes.filter((note) => !note.isPinned);

  return { pinnedNotes, unpinnedNotes, deletedNotes };
};
